import { render } from "./Sidebar2.vue?vue&type=template&id=499c904e"
import script from "./Sidebar2.vue?vue&type=script&lang=js"
export * from "./Sidebar2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__